import { HTTPClient } from '@abaco/web-common/src/HTTP';
import TokensResources, { Messages } from './TokensResources';
import { VueRouter } from '@abaco/web-common/src/app';
import { BASE } from './models/Constants';

export default class PasswordResources {

    private unAuthHttp = new HTTPClient();

    constructor(private http: HTTPClient, private tokenResources: TokensResources, private router: VueRouter) { }

    public async changePassword(oldPassword: string, newPassword: string): Promise<Messages> {
        const httpRes = await this.http.put(`${BASE}/change-password`, { oldPassword, newPassword });
        const res = httpRes.data;
        const messages: Messages = {
            warnings: [],
            errors: res.errors
        };

        return messages;
    }

    public async unAuthChangePassword(userid: string, oldPassword: string, newPassword: string): Promise<Messages>{
        const httpRes = await this.unAuthHttp.put(`${BASE}/unauth-change-password`, { userid, oldPassword, newPassword });
        const res = httpRes.data;
        const messages: Messages = {
            warnings: [],
            errors: res.errors
        };
        
        return messages;
    }

    public async isPasswordOk(password: string): Promise<Messages>{
        const httpres = await this.unAuthHttp.post(`${BASE}/is-password-ok`, {password});
        const messages: Messages = {
            warnings: [],
            errors: httpres.data.errors
        };
        return messages;
    }

}
